import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['answer', 'openAnswerButton', 'closeAnswerButton', 'largeCategory', 'category', 'questionTitle', 'categoryContainer']

  get className () {
    return this.element.dataset.classname
  }

  initialize () {
    if (this.hasAnswer()) {
      this.openAnswer()
    } else {
      this.excludeSendingForm()
    }
  }

  openAnswer () {
    this.answerTarget.classList.remove(`${this.className}::display-hidden`)
    this.openAnswerButtonTarget.classList.add(`${this.className}::display-hidden`)
    this.closeAnswerButtonTarget.classList.remove(`${this.className}::display-hidden`)
    this.includeSendingForm()
  }

  closeAnswer () {
    this.answerTarget.classList.add(`${this.className}::display-hidden`)
    this.openAnswerButtonTarget.classList.remove(`${this.className}::display-hidden`)
    this.closeAnswerButtonTarget.classList.add(`${this.className}::display-hidden`)
    this.excludeSendingForm()
  }

  excludeSendingForm () {
    this.answerTarget.querySelectorAll('input, select, textarea').forEach(element => {
      element.disabled = true
    })
  }

  includeSendingForm () {
    this.answerTarget.querySelectorAll('input, select, textarea').forEach(element => {
      element.disabled = false
    })
  }

  changeLargeCategory () {
    if (this.categoryContainerTarget.querySelector('p')) {
      this.categoryContainerTarget.querySelector('p').remove()
    }

    this.filterCategories()
  }

  filterCategories () {
    const largeCategory = this.largeCategoryTarget.value
    const categories = JSON.parse(this.largeCategoryTarget.dataset.category)[largeCategory]
    const id = 0
    const name = 1

    if (categories) {
      this.categoryTarget.innerHTML =
      '<option value="">カテゴリを選択してください</option>' +
      categories.map((category) => (
      `<option value="${category[id]}">${category[name]}</option>`
      )).join('')
    } else {
      this.categoryTarget.innerHTML = '<option value="">大カテゴリを選択してください</option>'
    }
  }

  changeCategory () {
    const facilityId = this.categoryTarget.dataset.facilityId
    const categoryId = this.categoryTarget.value

    if (this.categoryTarget.value) {
      fetch(`/api/nursing_facilities/${facilityId}/questions/count/?category_id=${categoryId}`)
        .then(response => response.json())
        .then(questionsCount => this.displayQuestionsCount(questionsCount.result))
    }

    this.inputTitle()
  }

  inputTitle () {
    const categoryIndex = this.categoryTarget.selectedIndex
    const categoryName = this.categoryTarget.options[categoryIndex].text

    if (!this.categoryTarget.value || categoryName === 'その他') {
      this.questionTitleTarget.value = ''
    } else {
      this.questionTitleTarget.value = `${categoryName}についての質問です`
    }
  }

  displayQuestionsCount (quesitonsCount) {
    if (this.categoryContainerTarget.querySelector('p')) {
      this.categoryContainerTarget.querySelector('p').textContent = `同じカテゴリでの質問が${quesitonsCount}件登録されています`
    } else {
      const quesitonsCountParagraph = document.createElement('p')
      quesitonsCountParagraph.textContent = `同じカテゴリでの質問が${quesitonsCount}件登録されています`
      this.categoryContainerTarget.append(quesitonsCountParagraph)
    }
  }

  hasAnswer () {
    const answer = this.answerTarget.dataset.hasAnswer
    return JSON.parse(answer.toLowerCase())
  }
}
